// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

const ANDROID_EMULATOR_HOST = '10.0.2.2'

/** The Android emulator reaches this machine at 10.0.2.2, not localhost. */
const apiBaseUrlForDevServer = (url: string): string => {
  if (typeof window === 'undefined' || window.location.hostname !== ANDROID_EMULATOR_HOST) return url
  return url.replace('://localhost', `://${ANDROID_EMULATOR_HOST}`).replace('://127.0.0.1', `://${ANDROID_EMULATOR_HOST}`)
}

export default {
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
  isStaging: import.meta.env.MODE === 'staging',
  mode: import.meta.env.MODE as 'production' | 'development' | 'staging',
  apiBaseUrl: apiBaseUrlForDevServer(import.meta.env.VITE_BASE_API_URL),
  receiptS3Bucket: import.meta.env.VITE_RECEIPT_S3_BUCKET,
  webAppBaseUrl: import.meta.env.VITE_WEB_APP_URL,
}
